import { SUPPORTED_LOCALES } from '../i18n/config';

export function gaisukeFxPublicPath(locale: string): string {
  if (locale === 'ja' || locale.startsWith('ja-')) return '/arena/fx';
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    return `/${locale}/arena/fx`;
  }
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) {
    return `/${short}/arena/fx`;
  }
  return '/arena/fx';
}

export function gaisukeFxCanonicalRedirect(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/ja/arena/fx') return '/arena/fx';
  return null;
}

export function isGaisukeFxPublicPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/arena/fx') return true;
  return SUPPORTED_LOCALES.some((loc) => path === `/${loc}/arena/fx`);
}
